import { createStore, combineReducers, applyMiddleware, compose } from "redux";
import thunk from "redux-thunk";
import {
  userReducer,
  loaderReducer,
  optionsReducer,
  langReducer,
  notificationReducer,
  stockReducer,
  artesianReducer,
  storageReducer,
} from "./reducers";

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const rootReducer = combineReducers({
  user: userReducer,
  loader: loaderReducer,
  options: optionsReducer,
  lang: langReducer,
  notification: notificationReducer,
  stock: stockReducer,
  artesian: artesianReducer,
  storage: storageReducer,
});

const store = createStore(
  rootReducer,
  composeEnhancers(applyMiddleware(thunk))
);

export default store;
